import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { OrganizationProfile } from '~/jobiqo/types/types';

interface OrganizationDetailHeaderExtraInfoSlotProps {
  /**
   * The organization profile entity.
   */
  organization: Slottable<OrganizationProfile>;
}

export default function OrganizationDetailHeaderExtraInfoSlot({
  organization,
}: OrganizationDetailHeaderExtraInfoSlotProps) {
  return null;
}
export { OrganizationDetailHeaderExtraInfoSlot };
